<template>
    <div class="container">
        <a-page-header class="page-header icon" @back="() => null" :sub-title="sub_title">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/setting')">
                <use xlink:href="#icon-xitongshezhitubiao" />
            </svg>

            <template #title> 系统设置<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    系统设置
                </div>
                <a-menu
                    class="menu"
                    mode="inline"
                    v-model="selected_menu"
                    :default-open-keys="['general', 'basic_data', 'other', 'secure', 'auth']"
                    :inlineIndent="16"
                >
                    <a-menu-item key="general" @click="on_jump('general')">通用设置</a-menu-item>
                    <!-- <a-menu-item key="point" @click="on_jump('point')">积分设置</a-menu-item> -->
                    <!-- <a-menu-item key="dingtalk" @click="on_jump('dingtalk')">钉钉设置</a-menu-item> -->
                    <!-- <a-menu-item key="contract" @click="on_jump('contract')">合同设置</a-menu-item> -->

                    <a-menu-item key="ip_whitelist" @click="on_jump('ip_whitelist')">IP白名单</a-menu-item>

                    <a-menu-item-group title="基础数据">
                        <a-menu-item key="data_source" @click="on_jump('data_source')">来源管理</a-menu-item>
                        <a-menu-item key="member_tag" @click="on_jump('member_tag')">客户标签管理</a-menu-item>

                        <!-- <a-menu-item
                            key="data_usual_address"
                            @click="on_jump('data_usual_address')"
                        >常用地址</a-menu-item> -->
                    </a-menu-item-group>

                    <a-menu-item-group title="权限管理">
                        <a-menu-item key="user" @click="on_jump('authority/user')">用户管理</a-menu-item>
                        <a-menu-item key="service" @click="on_jump('authority/service')">客服管理</a-menu-item>
                        <a-menu-item key="group" @click="on_jump('authority/group')">部门管理</a-menu-item>
                        <a-menu-item key="role" @click="on_jump('authority/role')">角色管理</a-menu-item>
                    </a-menu-item-group>
                </a-menu>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selected_menu: ["member"],
                sub_title: "用户管理",
                menu: [
                    { name: "通用设置", value: "general" },
                    { name: "积分设置", value: "point" },
                    { name: "项目管理", value: "data_project" },
                    { name: "科室管理", value: "data_subject" },
                    { name: "医生管理", value: "data_doctor" },
                    { name: "产品管理", value: "data_product" },
                    { name: "来源管理", value: "data_source" },
                    { name: "IP白名单", value: "ip_whitelist" },
                    { name: "行业管理", value: "industry" },
                    { name: "常用地址", value: "data_usual_address" },
                    { name: "钉钉设置", value: "dingtalk" },
                    { name: "天猫类目", value: "category_tmall" },
                    { name: "店铺标签", value: "resource_tag" },
                    { name: "客户标签管理", value: "member_tag" },
                    { name: "用户管理", value: "user" },
                    { name: "部门管理", value: "group" },
                    { name: "角色管理", value: "role" },
                    { name: "客服管理", value: "service" },
                ],
            };
        },
        created() {
            this.where();

            this.$store.commit("change_state", {
                name: "sidebar_key",
                value: "setting",
            });
        },
        watch: {
            $route() {
                this.where();
            },
        },
        methods: {
            where() {
                let current = window.location.pathname.split("/").pop();
                this.selected_menu = [current];

                this.menu.filter((v) => {
                    if (current === v.value) {
                        this.sub_title = v.name;
                    }
                });
            },
            on_jump(v) {
                return this.$router.push(`/setting/${v}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-container {
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
        }
    }
</style>
